import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import KEYBlue from '../common/keylist-blue';

const CoreValues = () => {
    return (
        <div className="section-py dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="mb-5">Our Core Values</h2>
                        <p className="text-secondary dark:text-secondary fs-md fw-400 mb-5">
                            Our values define us and reflect in our actions, our purpose, and everything we do here at Moweb
                            Limited Private Limited. They shape the culture that fosters innovation, guides our actions to face
                            challenges, and helps us exceed customer expectations.
                        </p>
                        <div className="lg:grid row lg:grid-cols-2">
                            <div className="gap-5 mb-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                <KEYBlue text="Life-long learning and pursuit of knowledge" />
                                <KEYBlue text="Transparency, honesty, and ownership" />
                                <KEYBlue text="Open, inclusive, and diverse work environment" />
                            </div>
                            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                <KEYBlue text="Dedicated to achieving high standards of customer satisfaction" />
                                <KEYBlue text="Optimistic, collaborative, and building long-term partnerships" />
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-6">
                        <div className="pl-11 pe-responsive">
                            <div className="our-team-success relative h-full">
                                <ul className="our-team-success-box  mb-0  pl-0">
                                    <li className="our-team-success_item">
                                        <div className="our-team-success_item_in">
                                            <div className="year-success relative">
                                                <div className="relative flex lg:items-center mr-4">
                                                    <div className="fifteen-sec inline-block">
                                                        <h3 className="mb-0 fs-xxl fw-700 text-white">15</h3>
                                                        <span></span>
                                                    </div>
                                                    <div className="success-main">
                                                        <p className="fs-md fw-700 mb-0">
                                                            Years <br></br> Of Success
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="our-team-success_item">
                                        <Link href={''} target="_blank" rel="nofollow">
                                            <Image
                                                src="/img/career/img-seo-team@2x.webp"
                                                width={279}
                                                height={217}
                                                alt="seo-team"
                                                title="seo-team"
                                                loading="lazy"
                                            />
                                        </Link>
                                    </li>
                                    <li className="our-team-success_item">
                                        <Link href={''} target="_blank" rel="nofollow">
                                            <Image
                                                src="/img/career/img-session-time@2x.webp"
                                                width={300}
                                                height={307}
                                                alt="session-time"
                                                title="session-time"
                                                loading="lazy"
                                            />
                                        </Link>
                                    </li>
                                    <li className="our-team-success_item">
                                        <Link href={''} target="_blank" rel="nofollow">
                                            <Image
                                                src="/img/career/img-mobile-lead@2x.webp"
                                                width={330}
                                                height={183}
                                                alt="mobile-lead"
                                                title="mobile-lead"
                                                loading="lazy"
                                            />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoreValues;
